<p-confirmDialog
  acceptButtonStyleClass="p-button-danger"
  acceptIcon="none"
  rejectButtonStyleClass="p-button-secondary"
/>
<div class="flex flex-col gap-2">
  @if (isLoadingInboxes) {
    <div
      class="flex items-center justify-center full-height"
    >
      <p-progressSpinner/>
    </div>
  } @else {
    <div class="flex justify-between px-4 py-4">
      <div class="flex gap-2">
        <div class="flex gap-2 items-center justify-center">
          <p class="font-semibold">Select Fax Inbox:</p>
          <p-select
            appendTo="body"
            class="w-80"
            optionLabel="label"
            placeholder="Select"
            [options]="inboxOptions"
            (onChange)="onInboxChange($event)"
            [(ngModel)]="selectedInbox"
          />
        </div>
        @if ((isLoadingTableData$ | async) === false) {
          <div
            class="flex gap-2 items-center justify-center"
          >
            <p-toggleswitch
              styleClass="toggle-sm"
              ngDefaultControl
              data-test-id="highlighted-switch"
              [disabled]="!selectedInbox"
              [style]="{ height: '20px' }"
              [(ngModel)]="showArchive"
              (onChange)="onArchiveChange($event)"
            ></p-toggleswitch>
            <span>Archived Faxes</span>
          </div>
        }
      </div>
      <div class="flex gap-2">
        <button
          severity="secondary"
          icon="pi pi-refresh"
          label="Reload"
          pButton
          [disabled]="!selectedInbox"
          (click)="reloadClicked()"
        ></button>
        <button
          severity="secondary"
          icon="pi pi-filter-slash"
          label="Clear All Filters"
          pButton
          [disabled]="!selectedInbox"
          (click)="resetTableState()"
        ></button>
        <div class="divider"></div>
        <button
          class="p-button"
          icon="pi pi-send"
          label="Move Fax"
          pButton
          [disabled]="!selectedRow || showArchive"
          (click)="openMoveFaxModal()"
        ></button>
        <div>
          <button
            class="p-button"
            icon="pi pi-angle-down"
            iconPos="right"
            label="Fax Action"
            pButton
            [disabled]="faxActionsDisabled"
            (click)="faxActionMenu.toggle($event)"
          ></button>
          <p-menu
            #faxActionMenu
            appendTo="body"
            [popup]="true"
            [model]="faxActionMenuOptions"
          />
        </div>
      </div>
    </div>
    <div class="px-4">
      @if (isLoadingTableData$ | async) {
        <div
          class="flex flex items-center justify-center"
        >
          <p-progressSpinner styleClass="w-16 h-16"/>
        </div>
      }
      <ifa-table-lazy
        #inboundFaxesODataTable
        [columnConfig]="columnConfig"
        [dataKey]="'inboundFaxId'"
        [filterable]="true"
        [hidden]="isLoadingTableData$ | async"
        [sortField]="defaultFaxesSort.field"
        [sortOrder]="defaultFaxesSort.order"
        [stateKey]="'InboundFaxes:Table:State'"
        [tableData]="tableData"
        [total]="total"
        (rowClicked)="handleRowClicked($event)"
        (lazyLoad)="handleTableLazyLoad($event)"
      />
    </div>
  }
</div>
<ifa-global-toast/>
